import { FC, memo } from "react";

const ByPass: FC = () => {
  return (
    <>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.50016 0.582031C4.13016 0.582031 0.583496 4.1287 0.583496 8.4987C0.583496 12.8687 4.13016 16.4154 8.50016 16.4154C12.8702 16.4154 16.4168 12.8687 16.4168 8.4987C16.4168 4.1287 12.8702 0.582031 8.50016 0.582031ZM12.4585 8.4987C12.4585 8.93592 12.1041 9.29036 11.6668 9.29036H5.3335C4.89627 9.29036 4.54183 8.93592 4.54183 8.4987C4.54183 8.06147 4.89627 7.70703 5.3335 7.70703H11.6668C12.1041 7.70703 12.4585 8.06147 12.4585 8.4987Z"
          fill="#757575"
        />
      </svg>
    </>
  );
};

export default memo(ByPass);
